export var ApprovalStatus = /*#__PURE__*/ function(ApprovalStatus) {
    /** Indicates the approval is in requested state */ ApprovalStatus["Requested"] = "requested";
    /** Indicates the approval is in approved state */ ApprovalStatus["Approved"] = "approved";
    /** Indicates the approval is in rejected state */ ApprovalStatus["Rejected"] = "rejected";
    /** Indicates the approval is in cancelled state */ ApprovalStatus["Cancelled"] = "cancelled";
    /** Indicates the approval is in an unknown state */ ApprovalStatus["UnknownFutureValue"] = "unknownFutureValue";
    return ApprovalStatus;
}({});
